import { IBetsByServicesModelItem } from '../../../../repositories/auction/v1/get-bets-position';
import { IBetPosition } from '../../../../redux/reducers/betPosition/types';

export function mapBetPosition(betPosition: IBetsByServicesModelItem): IBetPosition {
  const { page, offerPosition } = betPosition;

  return {
    page: page || null,
    offerPosition: offerPosition || null,
  };
}
